export default __webpack_public_path__ + "4343d6ec50614bf0b4a4186b35bbcec6.otf";